<template>
  <transition name="search-payment-success-dialog-fade">
    <div v-if="visible" class="search-payment-success-dialog" @click.self="handleClose">
      <div class="panel">
        <button type="button" class="close" aria-label="关闭支付成功弹窗" @click="handleClose" />

        <div class="headline">
          <img src="../../../assets/home-confirm/dialogs/payment-success.svg" alt="支付成功" class="icon" />
          <p class="title">支付成功</p>
        </div>

        <p class="desc">
          <span class="desc-normal"> 请去网站首页下方 </span>
          <button type="button" class="link" @click="handleGotoOrders">
            我的订单
          </button>
          <span class="desc-normal">
            中查看信息，然后根据购买的信息去中国裁判文书网查看案例详情
          </span>
        </p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SearchPaymentSuccessDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleGotoOrders() {
      this.$emit("goto-orders");
    },
  },
};
</script>

<style scoped>
.search-payment-success-dialog {
  position: fixed;
  inset: 0;
  z-index: 1996;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  background: rgba(0, 0, 0, 0.5);
}

.panel {
  position: relative;
  box-sizing: border-box;
  width: 445px;
  height: 272px;
  padding: 15px 20px 62px 60px;
  background: #ffffff;
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.24);
}

.close {
  position: absolute;
  top: 15px;
  right: 20px;
  width: 14px;
  height: 14px;
  border: 0;
  padding: 0;
  background: url("../../../assets/home-confirm/dialogs/payment-success-close.svg") center / 14px 14px no-repeat;
  cursor: pointer;
}

.headline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 40px 88px 0 49px;
  min-width: 228px;
  height: 64px;
}

.icon {
  width: 64px;
  height: 64px;
}

.title {
  margin: 0;
  color: #1db14e;
  font-size: 34px;
  font-weight: 700;
  line-height: 40px;
}

.desc {
  margin: 37px 0 0;
  width: 326px;
  color: #000000;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}

.desc-normal {
  color: #333333;
}

.link {
  border: 0;
  padding: 0;
  background: transparent;
  color: #d92f24;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
}

.search-payment-success-dialog-fade-enter-active,
.search-payment-success-dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.search-payment-success-dialog-fade-enter-active .panel,
.search-payment-success-dialog-fade-leave-active .panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.search-payment-success-dialog-fade-enter,
.search-payment-success-dialog-fade-leave-to {
  opacity: 0;
}

.search-payment-success-dialog-fade-enter .panel,
.search-payment-success-dialog-fade-leave-to .panel {
  opacity: 0;
  transform: translateY(12px) scale(0.98);
}
</style>
